/*英语*/
const en_US = {
  langsOptions: {
    en_US: 'English',
    hi_IN: 'Hindi',
    zh_CN: 'Chinese',
  },
  ThirdParty: {
    title: 'Third party login',
    ways: {
      Google: 'Google',
      Facebook: 'Facebook',
      Twitter: 'Twitter'
    }
  },
  pageTab: {
    Home: 'Home',
    Discounts: 'Promotions',
    Deposit: 'Deposits',
    Service: 'Customer',
    My: 'My',
    tab1Txt: 'Home',
    tab2Txt: 'Sports',
    tab3Txt: 'Casino',
    tab4Txt: 'Share',
    tab5Txt: 'Profile'
  },
  header: {
    login: 'Login',
    register: 'Register',
    service: 'Customer Support',
  },
  newsTitle: ['Deposit Notice', 'Maintenance Notice', 'Abnormal Occurrence', 'Special Promos', 'Winner Announced',
    'Special Notice', 'Special Recommends'
  ],
  register: {
    // username: 'Account',
    username: 'Username',
    // usernamePlace: 'containing 6-12 letters、number or combination',
    usernamePlace: '6~12 alphanumeric combination',
    usernamePlace1: 'Please enter user name',
    passwordPlace1: 'Please enter password',
    userError: 'Please enter 6~12 letters, numbers or a combination of letters and numbers',
    password: 'Password',
    passwordPlace: 'containing 6-12 letters、number or combination',
    passwordError: 'Please enter a password with 6~12 letters, numbers or a combination of letters and numbers',
    repeatPassword: 'Confirm Password',
    repeatPasswordPlace: 'Please type password again',
    phone: 'Phone Number',
    phonePlace: 'Please type phone number',
    phoneTips: 'Please provide correct phone number to authenticate',
    agentCode: 'Referral Code',
    agentCodePlace: 'leave this field empty if no Referral Code',
    vrifyCode: 'Verification Code',
    vrifyCodePlace: 'Please enter the verification code',
    rule: 'I agree',
    userRegistrationAgreement: '「User registration agreement」',
    newuserRegistrationAgreement: '「 To The Terms of Sevice」',
    loginbtn: 'LOGIN',
    existingAccount: 'Already have an account?',
    confirmTitle: 'success registered. Claim your cash bonus after real - name verification',
    authenticateNow: 'Get Verified Now',
    certifyLater: 'Get Verified later',
    successTips: 'Congratulations! New Register',
    successTips2: 'Welcome to GAMESTECH!',
    bankPart1: 'You can also..',
    bankPart2: 'bind bank account',
    bankPart3: 'Available for you to withdraw money anytime',
    startGame: 'Play Games',
    startDeposit: 'Deposit',
    remember: 'Remember me',
    require: 'required',
    noRequire: 'not required',
    realName: 'Real Name',
    realNamePlace: 'please enter real name',
    realNamePlace1: 'Please enter digits or letters, with only one space in between',
    qq: 'QQ',
    qqPlace: 'please enter QQ account',
    qqError: 'Please enter the QQ number whose first digit cannot be 0',
    wechat: 'Wechat',
    wechatPlace: 'please enter wechat',
    wechatError: '5 or more letters, numbers, underscores or minus signs, starting with a letter',
    email: 'Email',
    emailPlace: 'please enter correct email',
    withdrawPassword: 'Withdrawal Password',
    withdrawPasswordPlace: 'please enter withdrawal password',
    sendCode: "Verify",
    phoneCode: "6 digits OTP",
    loginTips1: "New Customer? ",
    loginTips2: "Open New Account",
    loginTips3: "In order to place bet(s) you must be a registered user",
    loginTips4: "By proceeding you confirm you are 18 years of age or older.",
    loginTips5: "Let's activate your account! ",
    loginTips6: "You have successfully created your account! To unlock your welcomeoffer and start playing, check your email and click the activation link.",
    registerBtn: 'Register Now',
    registerBtn1: 'SignUp',
    signUp: 'Create New Account',
    signUp1: 'Sign up',
    login: 'Sign in',
    signLogin: 'Sign in with google',
    signLoginFb: 'Sign in with facebook',
    signRegister: 'Sign Up with Google',
    signRegisterFB: 'Sign Up with Facebook',
  },
  ValidTips: {
    name: 'real name verification done，',
    phone: 'phone verification done ，',
    email: 'email verification done，',
    conactService: 'please contact livechat for any change ！',
    noPhone: 'Invalid Phone Verification,Please Proceed For Manual Verification',
    noDrawPwd: 'no withdrawal password,please set up',
    noPhoneDrawPwd: 'Invalid Phone Verification,no withdrawal password,please complete all information',
	noPhoneDrawPwd2: "Please fill up mobile number and withdrawal pin before binding bank account",
  },
  download: {
    title: '',
    app: 'APP',
    appDownload: '11ic APP',
    subTitle: 'Safety | Reliable| Fast',
    downloadNow: 'Download'
  },
  nav: {
    HotGame: 'Hot Games',
    Sport: 'Sports',
    Live: 'Live Casino',
    CatchFish: 'Fishing',
    Slot: 'Slots',
    Rummy:'Chess & Rummy',
    Lottery: 'Lottery',
    CardGame: 'Card Game',
    vip:'VIP',
    discount:'Promotions',
    Commission:'Commission',
    Blog:'Blog',
  },
  agency: {
    title: 'affiliatess Program',
    affiliatesAgree: 'affiliatess Agreement',
    agencyLogin: 'affiliatess Login',
    agencyRegister: 'Register as affiliatess'
  },
  others: {
    save: 'Save',
    click: "Click",
    success: "success",
    total: "Total",
    all: 'All',
    selectLang: 'Select Langes',
    CustomerService: 'Contact Customer',
    roger: 'copy that',
    monetaryUnit: '₹',
    loadingTxt: 'Loading',
    refreshTxt: 'Refreshing',
    loadmore: 'Click to load more',
    noData1: 'No more data',
    noData2: 'Sorry…. No data',
    noData3: 'No more records',
    confirm: 'Confirm',
    cancel: 'Cancel',
    Delete: 'Delete',
    next: 'Next',
    tips: 'Notification',
    refreshSuccess: 'success refresh',
    copy: 'copy',
    copySuceess: 'success copied',
    select: 'Please select',
    select1: 'SELECT',
    finish: 'Finished',
    close: 'close',
    search: 'Search',
    searchGame: 'Search for games',
    reset: 'Reset',
    startTime: 'Start time',
    endTime: 'End time',
    timeError: 'Please select the start time and end time, and the start time must be less than the end time',
  },
  Forms: {
    agreeTips: 'Please check the registration terms !',
    requiredFields: 'This item is required',
    gameAccount: 'Username',
    nameCheck: 'Please enter 6~12 letters, numbers or a combination of letters and numbers',
    phone: 'Phone number',
    phoneCheck: 'Please type correct phone number',
    email: 'Email address',
    emailCheck: 'Email format error, please re-enter',
    sendCodeBefore: 'Send',
    sendCodeAfter: 'seconds',
    verifCode: 'Verification code',
    verifCodePlace: 'Type verification code',
    oldPwd: 'Old password',
    newPwd: 'New password',
    newPwdPlace: 'Please type new password',
    pwdDiff: 'The new password cannot be the same as the old password!',
    repeatPwd: 'Confirm new password',
    repeatPwdPlace: 'Please type the new password again',
    newDiff: 'password does not match',
    pwdError: 'enter password with 6~12 letters, numbers or a combination of letters and numbers',
    drawPwdError: 'enter password with 4 or more letters, numbers or a combination of letters and numbers',
    sendSuccess: 'success sent'
  },
  upload: {
    imgSize: 'M',
    imgSizeTxt: 'Image size',
    imgType: 'Image type',
    select: '+ select upload file',
    successTips: 'upload success',
    errorTips: 'Size not bigger than'
  },
  service: {
    live_chat: 'Live Chat',
    whatsapp: 'Whatsapp',
    telegram: 'Telegram',
    commonProblem: 'FAQ'
  },
  discounts: {
    join: 'DETAIL',
    queryresult: 'Searching result',
    userUpgrade: 'Upgrade query',
    betOrderNo: 'Please enter the bet number',
    needLoin: 'log in and find your bonus to claim',
    noDiscounts: 'no available promos!',
    moreDiscount: 'View more promos',
    getBonus: 'Receive bonus',
    discountsReceived: 'Claim Bonus',
    checkPlatform: 'Please select platform',
    checkMoney: 'Please enter amount',
    checkBisnum: 'Please bet slip number',
    userInformation: {
      userAccount: 'Username',
      levelInfo: 'Current Tier',
      totalBetflow: 'Total amount betted',
      totalUpAmount: ' total tier status bonus',
      totalWeekAmount: 'total  weekly bonus',
      totalMonthAmount: 'total monthly bonus',
      nextLevelBetflow: 'Bets required for upgrade'
    },
    tips1: 'Current and Upcoming Campaigns!',
    unlogined: {
      txt1: "FANTASTIC PROMOTIONS",
      txt2: "Win amazing prizes",
      txt3: "Here you will find our latest and greatest promotions.",
      txt4: "Tailored to your taste and super easy to find.",
      txt5: "Bookmark this page and never miss an opportunity again.",

      txt6: "Check back here to find",
      txt7: "Amazing promotions",
      txt8: "Brand New Rewards",
      txt9: "Brilliant Bonuses to Claim",
      txt10: "Join now and find out more!",
      txt11: "MOST POPULAR GAMES"
    }
  },
  // 存款
  Deposit: {
    orderTip: 'Your deposit request is sent',
    referralAmount: 'Recommended recharge amount',
    saveLimit: 'Deposit Limit',
    receiptAccount: 'Account Name',
    receiptAccountPlace: 'enter vaild account name',
    saveMoneyNum: 'Deposited Amount',
    saveMoneyNumPlace: 'enter vaild deposited amount',
    orderName: 'UTR / Reference No.',
    orderName2: 'depositor',
    orderNamePlace: 'enter vaild depositor name',
    saveCertificate: 'Transaction Receipt',
    saveCertificatePlace: 'enter vaild transaction receipt',
    payTutorial: 'Payment tutorial',
    orderNumber: 'Transaction Number',
    receiptMoney: 'Amount',
    receipt: 'Payment Received',
    account: 'Account Number',
    timer: 'Submit Time',
    finish: 'Done',
    base: {
      title: 'Deposit',
      savaType: 'Please choose payment option',
      nonsupport: 'Sorry, the payment option is not supported'
    },
    bankTransfer: {
      title: 'Bank transfer',
      bankAddr: 'IFSC CODE',
      bank: 'Bank',
      beneficiary: 'Account Name',
      account: 'Account Number',
      contactUs: 'Please contact Customer Support',
      sendTips: 'Request has been sent',
      orderMoney: 'amount',
      orderDueBank: 'beneficiary bank',
      oderBankName: 'account name',
      transfer: 'inter-bank transfer',
      transferTips1: 'deposit will reflect in your account 30 minutes after',
      transferTips2: 'money transfer arrivial time depends.If you did not receive the fund within 24 hours after you fund is processed, please contact Customer Support!',
      typeofpayment: 'Type of payment',
      Transferamount: 'Transfer amount',
      TransferUSDTAmount: 'You want transfer USDT amount',
      RupeeAmount: 'Will approve rupee amount'
    },
    Recharge: {
      title: 'Deposit',
      payType: 'payment options',
      payChannel: 'select a payment channel',
      channel: 'channel',
      bank: 'choose a bank',
      bankPlace: 'choose paying bank',
      selectMoney: 'select amount',
      saveMoney: 'deposit amount',
      saveMoneyPlace: 'enter amount',
      fixedMoney: 'enter fixed amount',
      insufficient: 'insufficient balance',
      payOthersType: 'change other payment method',
      back: 'back',
      paySuccess: 'success loaded',
      finish: 'done payment '
    },
    Neteller: {
      title: 'Neteller',
      cost: 'FEE',
      tips: 'Your deposit request is sent'
    },
    Paytm: {
      title: 'Paytm',
    },
    Skrill: {
      title: 'Skrill'
    }
  },
  forget: {
    title: 'Forgot your password',
    RetrieveSMS: 'SMS password recovery',
    MailboxRetrieve: 'Email password recovery',
    CustomerRetrieve: 'password recovery by Customer Support',
    checking: 'Verification',
    userPlace: 'Enter your username',
    phonePlace: 'Enter the connected phone number',
    emailPlace: 'Enter the connected Email address',
    resetPwd: 'Reset password',
    tips: 'failed redirecting to page? Kindly contact Customer Support>',
    tips1: 'SMS with Verification Code has been sent to your phone. If not received, please click send verification code.',
    tips2: 'A email with Verification Code has been sent to your email address. If not received, please click send verification code.',
    tips3: 'Note: the email might be mistaken for spam; pls also check the spam folder',
    submit: 'Submit',
    successTips1: 'password recovery',
    successTips2: 'Your password was success created. '
  },
  signIn: { // 签到
    signTipsReward1: 'Sign in to send prizes',
    signTipsReward2: 'Sign-in benefits',
    surprise: 'Surprise',
    success: 'Sign successfully',
    successTips: 'Can accumulate cash~',
    daySign: 'Daily sign in',
    otherIncentives: 'other rewards',
    cashBonus: 'cash bonus',
    currentIntegral: 'Current points',
    sign: 'sign in',
    signed: 'already signned in',
    signTips1: 'You have a pending reward point.',
    signTips2: 'Consecutively signin',
    signTips3: ' Dont forget sign in today!~',
    signTips4: 'sign in for tomorrow',
    signTips5: 'Signing in tomorrow for suprise',
    Integral: 'reward points',
    signInTalent: 'Singin expert',
    awardTips1: 'congratulations！',
    awardTips2: 'Contact Customer Support to claim your real prize',
    integralChange: 'Redemption',
    integral: 'Required points',
    confirmChange: 'confirm the redemption',
    signNow: 'sign in NOW',
    gameOptions: [
      'Candy Land', 'Identity V', 'Pandora is Box', 'Dolphin', 'Girl with guns', 'Red Dragon Wild',
      'Gold Factory', 'Top Trumps Celebrities', ' Vikingmania', 'High society', 'Egyptian Goddess',
      'Zhao Cai Jing Bao',
      'Life of Riches', 'Lost Vegas', 'Big Wheel', 'Jin Ping Mei 2', 'Bull Bull chess', 'Gold Panther',
      'Super 888', 'Sushi Bar Slot', 'Age Of Discovery', 'Monkey Slot', 'Tarzan', 'Great adventure',
      'Pharaoh is tomb slot', 'Ways of fortune', 'Lucky Panda Slot', 'Fire Rooster', 'Tarzan',
      'Asian Fantasy Slot', 'Shaolin Fortunes', 'The three Kingdoms', 'Dream Date', 'Emotion coins',
      'Forbidden Throne', ' Playboy'
    ],
    choosePrize: 'Select prize',
    lackOfIntegral: 'insufficient points',
    continuously: 'consecutively signin',
    jetton: 'chip',
    size: '₹',
    signInTab: {
      integral: 'History',
      cash: 'Cash Back',
      forRecord: 'redeem history',
      rule: 'policy'
    },
    myself: 'My',
    recordTips1: 'You have a pending reward point',
    signDay: 'consecutively signin',
    day: 'day',
    dayModifier: '',
    noDataTips: 'every single point is a start of capital.'
  },
  mine: {
    welcome: 'Welcome',
    visitor: 'visitor',
    accountManageText: 'Account manage',
    bindNow: 'Act now to bind',
    bindSuccess: 'binding success',
    filtrate: 'filter',
    timers: 'time',
    timeOptions: {
      '90': 'all',
      '1': '24 hours',
      '7': '7 days',
      '30': '1 month'
    },
    minBaseOptions1: {
      SaveMonery: 'Deposit',
      Withdrawal: 'Withdraw',
      Wallet: 'Wallet',
      StationLetter: 'Message'
    },
    Withdrawal: {
      mainBalance: 'Main Wallet',
      addBank: 'add bank account',
      addUsdt:'Add digital currency address',
      balance: 'balance',
      detailsTitle: 'the bank statement',
      cash: 'Cash out is available',
      recharge: 'Deposit',
      drawMoney: 'Withdraw',
      platform: 'Platform',
      takeBack: 'takeBack',
      takeBack1: 'Return',
      addbankcard: {
        pageTitle: 'Withdrawal Bank Account',
        tips1: 'contact Customer Support to update phone number',
        tips2: 'no withdrawal password, do you want set a password?',
        tips3: 'Do you want set a password for your account safety?',
        personName: 'Card Holder',
        personNamePlace: 'Enter the card holder real name',
        bankName: 'Bank Name',
        bankNamePlace: 'Please select bank name',
        cardNumber: 'Bank Account Number',
        cardNumberPlace: 'must be 10 ~ 50 digits',
        cardNumberError: 'Please enter 10 ~ 50 digits bank card number!',
        bankBranch: 'IFSC Code',
        bankBranchPlace: 'enter vaild branch code',
        bankBranchPlace2: 'IFSC must contain a combination of 8-20 digits and letters',
        bankBindPhone: 'Mobile No. with bank',
        bankBindPhonePlace: 'Must be the contact number registered with bank',
        withdrawPassword: 'Withdrawal Password',
        withdrawPasswordPlace: 'enter withdrawal password'
      },
      addUsdtcard: {
				pageTitle: 'Digital currency address management',
				tips1: 'contact Customer Support to update phone number',
				tips2: 'no transaction password, do you want set a password?',
				tips3: 'Do you want set a password for your account safety?',
				personName: 'Card holder',
				personNamePlace: 'Please enter your name',
				currencyType: 'Currency type',
				currencyTypePlace: 'Please select currency type',
				depositAddress: 'Deposit address',
				depositAddressPlace: 'Please enter deposit address',
				phone: 'Phone number',
				phonePlace: 'Please enter phone number',
				phoneCode: 'Phone number verification code',
				phoneCodePlace: 'Please enter phone number verification code',
				withdrawPassword: 'Transaction password',
				withdrawPasswordPlace: 'enter transaction password',
                confirm: 'Confirm',
                addNow: 'Add now',
                sendCode:'Send verification code',
                sendCodeTip:'S)',
                TRC20: 'TRC20 digital currency',
                ERC20: 'ERC20 digital currency',
                HECO: 'HECO digital currency',
                OMNI: 'OMNI digital currency',
                phoneBindTip: 'You have not bound your phone number, please bind your phone number first',
                tipsError: 'Unknown system exception',
                passwordTips: 'The transaction password has not been set, do you want to go to set it?',
                safteyTips: 'To ensure account security, do you want to go and set it up?',
			},            
      Draw: {
        pageTitle: 'withdraw',
        money: 'withdraw amount',
        RupeeAmount:'Will withdraw USDT amount',
        moneyPlace: 'enter withdraw amount',
        pwd: 'withdraw password',
        pwdPlace: 'enter withdraw password',
        canDraw: 'Available Balance',
        drawTips1: 'withdraw amount more than',
        drawTips2: 'allowable',
        drawTips3: 'need withdraw password and phone verification before withdraw',
        drawTips4: ', avoid decimals',
        deleteTips1: 'delete bank account',
        deleteTips2: 'Contact Customer Support to delete bank account, Yes or No?',
        phoneTitle: 'phone number not verified',
        phoneConfirm: 'Verify NOW',
        phoneCancel: 'Verify later',
        pwdTitle: 'no withdraw password',
        pwdConfirm: 'Go setting NOW',
        pwdCancel: 'Go setting later',
        pwdInputTitle: 'enter withdraw password',
        deleteSucess: 'delete success.',
        takeBackSuccess: 'takeback success',
        applySuccess: 'apply success',
        check: {
          amount1: 'enter interger numbr bigger than 0',
          amount2: 'Insufficient balance',
          pwd: 'withdraw password not empty'
        }
      }
    },
    wallet: {
      title: 'wallet',
      balance: 'balance',
    },
    stationLetter: {
      title: 'website message',
      pageTab: {
        myMessage: 'My Message',
        sendMessage: 'Send New Message'
      },
      myMessageTab: {
        unread: 'Latest News',
        read: 'Read Message'
      },
      noMsg: 'No message',
      noMoreMsg: 'No more messages',
      deleteSelect: 'Delete Selected Messages',
      deleteSuccess: 'Deleted success',
      msgType: 'message type',
      msgTypeOptions: {
        money: 'withdraw and Deposit',
        discounts: 'Promotions',
        games: 'Game related',
        other: 'other question',
        proposal: 'Suggestion',
        complaint: 'Complaint'
      },
      theme: 'Main Subject Line',
      themePlace: 'input a subject line',
      desc: 'content',
      descPlace: 'input content',
      send: 'send',
      selectMsgType: 'select question type',
      sendSuccess: 'sent success'
    },
    minBaseOptions2: {
      discount: 'Promotions',
      latestDeposit: 'Latest Deposit',
      task: 'Task',
      betRecord: 'Bet Records',
      merchRecord: 'Transaction Record',
      lockAmount: 'Frozen funds details',
      gameCollect: 'My Collection',
      InviteFriends: 'Invite Friends',
      agentCenter: 'Agent Center',
      appDownload: 'APP download',
      affiliate: "Affiliate"
    },
    betRecord: {
      title: 'Bet records',
      total: 'total',
      size: 'Transaction numbers',
      betMoney: 'Bet amount',
      effectiveBet: 'Valid amount',
      profit: 'Profits amount',
      gameType: 'Game type',
      platNumber: 'Platform code',
      betOrder: 'Bet order number',
      betTime: 'Bet time',
      settltTime: 'Settletime',
      customTime: 'self-defined time',
      selectTime: 'selected time',
      startTime: 'Start time',
      endTime: 'End time',
      timeError: 'Please select the start time and end time, and the start time must be less than the end time',
      gameType: 'game types',
      noData: 'no slip data',
      gamelist: {
        '-1': 'All',
        '1': 'Slots',
        '2': 'Live Casino',
        '3': 'Sports',
        '4': 'Lottery',
        '5': 'Fish',
        '6': 'Card Game',
        '8': 'Other'
      }
    },
    LatestDeposit: {
    	title:'LatestDeposit',
      yes: "YES",
      no: "NO",
      continuePay: "Continue Payment",
    	cancel:'Revoke',
      dateTimes:'Trans. Date',
      Type:'Deposit Type',
      Amount:'Amount',
      ID:' Deposit ID',
      Status:'Status',
      Action:'Action',
      confirmTips:'Cancel your deposit',
      tipsTips1:'Your application has been revoked!',
      tipsTips2:'Reminder : Multiple Request Will Deemed To Account Suspended',
      Close:'Close',
    	goDeposit:'Go to Deposit List',
    	paytips1:'You still have unapproved deposits, ',
    	paytips2:'please wait for approval or revoke your deposit ticket',
    	gamelist: {
    		'0': 'Processing',
    		'1': 'Succeeded',
    		'2': 'Failed',
    		'3': 'Canceled',
    	}

    },
    tradingRecord: {
      title: 'transaction record',
      tradingType: 'transaction types',
      tradingTypeOptions: {
        0: 'all',
        1: 'system adjustment',
        2: 'Make deposits',
        3: 'quick withdraw',
        4: 'Import to game',
        5: 'Export to game',
        8: 'Promotion Bonus',
        9: 'Manual Deposit',
        10: 'Manual Withdraw',

        11: 'lottery purchase',
        12: 'lottery payout',
        13: 'lottery order cancelled',
        14: 'lottery daily task',
        16: 'Superior agent manually add',
        17: 'Purchase Yu Er Balance',
        18: 'Redeem Yu Er Balance',
        19: 'lottery purchase',
        20: 'lottery payout',
        21: 'lottery order cancelled',

        22: 'sports bet',
        23: 'sports win/loss',
        24: 'sports bet refund',

        30: 'invitation commission',

        40: 'Betting',
        41: 'Payout',

        90: 'tips',
        91: 'guess bet',
        92: 'guess payout ',
        93: 'guess cancelled',

        100: 'applying'
      }
    },
    tradingRecordDetails: {
      title: 'transaction details',
      orderNumber: 'order number'
    },
    lockAmount: {
      title: 'Frozen fund details',
      rechargeTab: 'Frozen Deposits',
      discountsTab: 'Frozen Promotion',
      platform: 'whole platform',
      platformPlace: 'select platform',
      lockStatus: 'lock status',
      lockStatusPlace: 'choose lock status',
      bonus: 'select bonus type',
      bonusType: 'bonus type',
      loackAmonutOptions: {
        all: 'all',
        lock: 'lock',
        unlock: 'unlock',
        cancel: 'cancel'
      },
      loackAmonutStatus: {
        deposit: {
          0: 'applying',
          1: 'success',
          2: 'failed',
          3: 'frozen',
          4: 'cancel '
        },
        bonus: {
          0: 'applying',
          1: 'processing',
          2: 'success claimed',
          3: 'decline',
          4: 'failed',
          5: 'unclaimed',
          6: 'not drawn'
        }
      },
      bonusTypeOption: {
        all: 'all',
        waterRebate: 'Turnover bonus',
        softLoan: 'Deposit bonus',
        rescueGold: 'Lose Rebate',
        upgradeAwards: 'VIP upgrade bonu',
        winAwards: 'Retain VIP bonus',
        otherPreferential: 'Sign up bonus',
        joinPreferential: 'Referal bonu'
      },
      platformOption: {
        all: 'All platforms',
        main: 'main account'
      },
      loackItem: {
        capital: 'capital',
        size: '₹',
        lockMoney: 'locked amount',
        waterComplete: 'turnover completed',
        waterTarget: 'turnover target',
        unlock: 'unlock',
        bonus: 'bonus title',
        moneyNum: 'amount',
        remainingWater: 'remain turnover request',
        platform: 'platform',
        unlocked: 'unlocked'
      }
    },
    invite: {
      title: 'invite friends',
      scan: 'scan to download APP',
      link1: 'affiliatess link',
      link2: 'Download APP',
      link3: 'Referral code',
      tips: 'use any of the register methods',
      activity: 'promotion details',
      account: 'account',
      receive: 'receive',
      received: 'CLAIMED',
      cashingPrize: 'CLAIM',
      outDate: 'Expired',
      noActivity: 'no promotion',
      anyWay: 'friend can choose any of the register methods'
    },
    accountManage: {
      title: 'Account Manage',
      nickName: 'Nickname',
      name: 'Real Name',
      phone: 'Phone Number',
      email: 'Email',
      loginPwd: 'Login Password',
      drawPws: 'Withdraw Password',
      loiginOut: 'Log Out',
      authe: 'Verify Now',
      edit: 'Edit',
      setting: 'Setting'
    },
    verifiedAuth: {
      title: 'real name verification',
      tips: 'Note:After real-name authentication, no change allowed. Your withdraw account name is your real name',
      name: 'Name',
      namePlace: 'enter real name',
      IDNO: 'ID number',
      IDNOPlace: 'enter ID number',
      successTips1: 'success! bonus release please check My Promotion 。',
      successTips2: 'Success real-name verification',
      nameValid: 'Do not send again real-name verification. Please contact Customer Support！'
    },
    mobileAuth: {
      title: 'phone verification',
      phoneError: 'phone number not matched',
      phonePlace: 'enter phone number',
      verifCodePlace: 'enter SMS verification code',
      successTips: 'success verification',
      authenticated: 'the phone no. has verified; do not repeat click'
    },
    emailAuth: {
      title: 'Email verification',
      tips1: 'We have sent an e-mail with a confirmation link to your email, please click the link to complete register.',
      tips2: 'Note: the email might be mistaken for spam; pls also check the spam folder.。',
      email: 'Email Address',
      emailError: 'invaild email',
      emailPlace: 'enter email address',
      verifCodePlace: 'enter verification code',
      codeSuccess: ' Sent verification code',
      successTips: 'email success',
      authenticated: 'Email has been authenticated, please do not repeat authentication'
    },
    editPwd: {
      title: 'change login password',
      tips: '#Note: Once you change your password, you will need to relog into your account instantly',
      oldPwdPlace: 'enter old password',
      successTips: 'login password success changed',
      loginOut: 'log in again'
    },
    withdrawPwd: {
      title: 'change withdraw password',
      pwdPlace: 'enter old password',
      newPwdPlace: 'enter new password',
      tips: 'Forgot your withdraw password? please contact Customer Support',
      successTips: 'withdraw password success created'
    }
  },
  wheel: { // 抽奖转盘
    title: 'Play lucky wheel',
    smalltitle: 'Great gifts make the sky high',
    lotteryNum: 'Remaining draw',
    lotterySize: 'draw(s)',
    winRecord: 'My winning history',
    noRecord: 'no winning until now',
    dispatched: 'Reward sent',
    winPrize1: 'Good luck, win',
    winPrize2: 'Big win!',
    sendPrize: 'Reward sent. Please check the transaction record',
    prizeTips: 'contact Cusotmer Support to claim',
    noPrizeNum: 'Remaining number of draws: ',
    prizeIng: 'Drawing Progress. do not repeat click',
    congratulation: 'congratulations',
    prizeInfo: 'Winning information',
    thanksJoin: 'Thank you for participation',
    lotterNeed: 'Lucky draw notes',
    rules: 'Activity Rules',
    start: 'Start',
    gameName: 'Wheel of fortune',
    history: 'Winning record',
    needLogin: 'You can log in to draw !'
  },
  betting: {
    title: 'GT Lottery',
    lottery: 'Lottery',
    stopBet: 'Bets are not allowed in the closed market',
    betMinAmount: 'Min bet amount',
    needLogin: 'You are not logged in yet!',
    AvailableBalance: 'available balance',
    betSuccess: 'success！',
    recharge: 'reload',
    inLottery: 'waiting for draw',
    rule: 'rules',
    issues: 'issue',
    rules: 'betting rules',
    betSubmit: 'place bet',
    addcart: 'add to cart',
    clear: 'clear',
    add: 'Join',
    totalTxt: 'total',
    noselected: 'select lucky numbers!',
    noEnoughMoney: 'no enough balance!',
	limitMix: "Betting amount cannot be less than minimum required amount",
    settleType: {
      all: 'all',
      noSettle: 'unsettle',
      settle: 'settle',
      win: 'win',
      lose: 'lose'
    },
    trafficList: {
      0: 'Number',
      10: 'Red',
      11: 'Yellow',
      12: 'Blue',
    },
    cartHead: {
      type: 'type',
      details: 'details',
      multiple: 'multiple',
      money: 'amount'
    },
    lotteryTab: {},
    countDown: 'count down',
    record: {
      title1: 'draw history',
      title2: 'my betting history',
      title: 'betting details',
      orderNo: 'tickets number',
      betMoney: 'bet amount',
      dealMoney: 'amount',
      serviceAmount: 'service fee',
      drawNum: 'draw number',
      betNum: 'bet number',
      status: 'status',
      rewards: 'rewards',
      betTime: 'betting time',
      tableHead: {
        Period: 'Tier',
        Price: 'jackpot',
        Numbers: 'draw numbers',
        Result: 'results'
      }
    },
    betChart: {
      title: 'Lottery Trend Chart',
      periodsNum: 'issue',
      lotteryNum: 'lottery number',
      statics: {
        showCount: 'show count',
        averageMiss: 'average miss',
        miss: 'miss',
        maxShwo: 'max show',
        maxMiss: 'max miss'
      },
    },
    mybetTxt: "My Bets",
    seeAll: "See All",
    amountTxt: "Bet Slip",
    editAmout: "Edit quick amount",
    fast: "Fast",
    bets: "bets",
    totolNum: "Total Bet Slip",
    totolAmount: "Total Bet Amount",
    comfirmBet: "Confirm Bets",
  },
  games: {
    title: 'Games',
    play: 'Play Now',
    acount: 'Game Wallet',
    amount: "Amount balance",
    stayTuned: 'Stay Tuned',
    collectSuccess: 'Collection success!',
    collectCancel: 'Canceled collection!',
    hotGameType: {
      HotGame: 'Top Hits',
      Live: 'Live Casino',
      Sport: 'Sports',
      Slot: 'Slots',
      CatchFish: 'Catch Fish'
    },
    liveType: {
      '0': 'All',
      '1':'Roulette',
      '2':'SIC BO',
      '3': 'Baccarat',
      '4':'Dragon Tiger',
      '5':'Black Jack',
      '6':'Other'
    }
  },
  Tasks: {
    reward: "Claim bonus",
    invite: "Invite",
    play: 'Play games',
    receiveSuccess: "task claimed success！",
    receiveTips: "Reminder: If daily task reward do not claim ,it will be reset",
    finish: "Complete",
    tab: {
      depositTask: "Deposit Task",
      inviteTask: "Invitation Task",
      gameTask: "Game Task",
    }
  },
  home: {
    matchTab: {
      best: "Best",
      league: "League",
      collect: "Collection"
    },
    payTitle: "Deposit Method",
    links: {
      agent: "Agent Joining",
      guide: "Guide",
      faq: "Faq",
      rule: "Rules",
      about: "About Us"
    },
    company: "Copyright © 2003-{year} 11ic (International) Ltd"
  },
  team: {
    title: "promote to get bonus",
    size: "INR",
    size2: "thousand",
    size2_2: "Lakh",
    size3: "More than",
    videos: "Video Tutorial",
    videoTips: "您的浏览器不支持该视频播放。",
    table: {
      times: "Time",
      superior: "Superior",
      amount: "Amount",
      status: "Status",
      rebateAmount: "Rebate amount",
      performanceQuota: "Player's Performance",
      txt1: "commission of every ten thousand ",

      rank: "Rank",
      account: "Account",
      id: "ID",
      title: "Sports Section ",
      searchPla: "Input player name"
    },
    tabNav: {
      promotion: "My Commission",
      performance: "Check Stats",
      directly: "Check Players",
      group: "TEAM Performance",
      invite: "Invite Friends"
    },
    Inquiry: {
      directly: {
        searchTxt: "Enter direct player’s Name",
        allNum: "Total Number of Players",
        newAdd: "Daily New Register",
        txt1: "Direct Affiliate Performance"
      },
      group: {
        searchTxt: "Enter Player Name of Team",
        allNum: "Total Number of TEAMS",
        newAdd: "New Additions of TEAM",
        txt1: "Number of players",
        txt2: "Performance of Team Today"
      }
    },
    CommissionRecordTitle: "Commission withdrawal record",
    promotion: {
      withdrawalTips1: "please input withdraw amount more than 0",
      withdrawalTips2: "your commission withdraw successful",
      info: {
        ID: "My Player ID",
        superiorID: "My Superior ID",
        temNums: "Total TEAM Members（New Members）",
        toDayPerformance: "TEAM Performance Today",
        players: "Total Direct Players（New Players）",
        todayDirectPerformance: "Direct Players Performance Today",
        yesterdayCommission: "Commission Yesterday",
        TodayCommission: "Commission Today",
        tips: "Equals to performance of TEAM + Direct Players"
      },
      commission: {
        nums: "Commission ready to be claimed",
        total: "Total Commission",
        withdrawal: "Commission Withdrawal",
        record: "Withdrawal record",
        ratio: "Commission ratio",
        tutorial: "Promotion tutorial"
      },
      inviteTips: "invite friends, you can earn cash bonus every day!",
      inviteLink: "Invitation Link",
      inviteCode: "Invitation code",
      withdrawalAmount: "Amount to withdraw: ",
      tutorial: {
        list1: [
          {
            txt: "How to promote to make money?",
            desc: "Scan QR code or click invitation link,choose to open it in the browser, register to download the game, and use your exclusive QR code event invitation link to promote it."
          },
          {
            txt: "Where is the promotion invitation code?",
            desc: "Click to invite friends , and you will have your own exclusive QR code and registration link. The members registered in this way can become your direct players, and the downline members you invited will be your direct team members.And many more, unlimited development can be achieved."
          },
          {
            txt: "Where to check report and commission?",
            desc: "Team page can check your team members,team company net win,direct members,direct affilaite performance,history total commission and avalible commission and so on."
          },
          {
            txt: "How to calculate performance?",
            desc: "Performance refers to valid bets of players.for example,you invite one player,he win 500 and lose 300 on next bet,his performance is 800."
          },
          {
            txt: "Requirement of deposit and withdrawl?",
            desc: "Deposit in member center,withdraw is available when finish 1 time turnover."
          },
          {
            txt: "How to withdraw?",
            desc: "First,transfer from commission in team page to wallet,then proceed to withdraw.choose the bank card you want to withdraw.bank card and name should be correct or will not withdraw successfully"
          },
          {
            txt: "How long for commission payout?",
            desc: "commission will credit daily.commission will be reset at 23:59pm every day.daily commission will payout refer to commission table base on how is the performance."
          }
        ],
        proxyTips: "affiliate commission ratio table",
        list2: [
          {
            txt: "Commission calculation",
            descList: [
              "Direct agent commission=total commission ratio*direct affiliate performance",
              "team commission=(total commission ratio-direct affiliates commission ratio)*team performane",
              "A commission=(B1direct affiliate commission+B1 team commission)+B2direct affiliate commission+B3diret affiliate commssion",
              "B1commission=C2 direct affiliates commission+C3 direct affilaites commssion"
            ]
          },
          {
            txt: "Total commission",
            descList: ["total commission=direct affiliates commission+team commission"]
          },
          {
            txt: "settlement time",
            descList: ["commission settled every day,commission based on daily performance."]
          }
        ]
      }
    },
    performance: {
      tabData: {
        today: "Today",
        yesterday: "Yesterday"
      },
      totalBetAmount: "All performance",
      selfBetAmount: "Direct Players Performance",
      teamBetAmount: "TEAM Performance",
      tips: "Performance made by Players & TEAM are all your profit",
      detailsTitle: "Sports Section "
    },
    RebateRatio: { // 返佣比例
      title: "Rebate ratio",
      tableTxt1: "Team performance/Daily",
    }
  },
  match: {
    InsufficientBalance : "The main account balance is insufficient, please recharge first!",
    more: "more",
    nodata: "No more matches",
    multiples: "All Multiples",
    clear: "Clear Betslip",
    betTotalMoney: "Place Bet",
    back: "Returns",
    winner: "winner",
    locked: "locked",
    autoOdds: "auto receive latest odds",
    autoOddsTips: "After selection, the ticketing success rate will be increased, and the odds will be based on the ticketing odds (the ticketing odds may be the same as the submitted odds)",
    done: "Done",
    limitMax: "Maximum bet amount exceeded",
    betResult: "Submit Successfully!",
    betRecord: "Search Betting History",
    continueBet: "Continue Betting",
    betAmount: "Number of Bets",
    noBetTips: "Please confirm bet amount",
    draw: "Draw",
    success: "Succeeded",
    failure: "Failure",

    records: {
      tips: "Reminder:  The current page only displays the betting records of GT Cricket, BTI, IBC, EXCHANGE betting records, please check in Other Games",
      nodata: "No data yet,start playing now",
      toBet: "Bet now",
      otherGame: "Other Games",
      items: {
        eventName: "Event Name",
        gametName: "Game Name",
        content: "Betting content",
        betAmount: "Bet amount",
        betOdd: "Betting Odds",
        odds: "Odds of  comfirmation",
        revenue: "Revenue",
        status: "Status",
        orderNo: "Order No."
      },
      status: {
        '99': "Unsettle",
        '100': "Settled",
        '1': "Win",
        '0': "Lose",
        '-1': 'Refund'
      },
    }
  },
  IPL:{
    title:'IPL Tournament',
    TotalBit:'Total output of 11ic coins',
    myBit:'My 11ic coins',
    myBonus:'My Bonus',
    rank:'rank',
    Rank:{
      title:'TOP 20 RANKING',
      MyRank:'My Rank:'
    },
    bet:{
      title1:'Predict the winner team',
      title2:'Place bets on your chosen winning team and earn coins',
      betslip:'Betslip',
      Winner:'Winner',
      BetAmount:'Bet Amount',
      Mycoin:'My 11ic coin balance:',
      noselected:'select team!',
      noamount:'Enter betting amount',
      noEnoughMoney:'no enough coin!'
    },
    CP:{
      title1:'Predict the Champion',
      title2:'Predict the Chamption and win xxx 11ic coins',
      YourChampion:'Your Champion',
      Confim:'Confim'
    },
    TW:{
      title1:'Exchange turnover to 11ic Coins',
      title2:'Redeem once every 24 hours',
      day:'Days of Betting',
      orders:'No. betting orders',
      amount:'Betting amount',
      bit:'Convert 11ic coins',
      Eover:'The event is over',
    },
    IE:{
      title1:'Every invites earn xx 11ic coins',
      title2:'Get 11ic coin in 3 easy steps',
      Invite:'Invite',
      Register:'Register',
      Deposit:'Deposit',
      tips:'Invite friends to register and verify account',
      InvitationLink:'Invitation Link',
      App:'Download App',
      code:'Invitation code',
      Total:'Total Invited',
      Coins:'Coins Reward',
      now:'Invite now',
    },
    SE:{
      title1:'Share & Earn Social media earn 11ic coins',
      title2:'Share on your social media account and earn 11ic coins reward Contact CS to claim coins',
      tips:'Participate and WIN upRs. 10 million prize pool ！'
    },
    Record:{
      ChampionPrediction:{
        Waiting:'Waiting for settlement',
        Noyet:'No results yet',
        Yc:'Your Champion',
        items:{
          Bonus:'11ic Coin Bonus',
          time:'Prediction Time',
          Result:'Result',
          Predict:'Predict your champion'
        },
        status: {
          '0': "Waiting for results",
          '1': "Win",
          '2': "Failed",
        },
      },
      TotalWager:{
        turnover:'Total turnover',
        Exchange:'Exchange to 11ic coins',
        Date:'Date'
      },
      Share:{
        Coins:'Total Coins',
        Invite:'Invite',
      },
      Invite:{
        Coins:'Total Coins',
        status:{
          '0': "Waiting to claim",
          '1': "Success",
          '2': "Failed",
        }
      },
    },
  },
  ghistory: {
    title: 'Bet Detail',
    Playerid: 'Player ID',
    gameid: 'Game ID',
    insurance: 'insurance',
    WinorLoss: 'Total win/loss',
    betTime: 'Bet time:',
    orderNo: 'Txn. ID',
    Status: 'Status',
    Provider: 'Provider',
    Event: 'Event',
    betArea: 'Bet area',
    gameName: 'Game name',
    total: "Total",
    Odds: 'Odds',
    TotalBets: 'Total Bets',
    ValidBets: 'Valid Bets',
    WinorLoss2: 'Win/Loss',
    close: 'close',
    Running: 'Running',
    Settled: 'Settled',
  }
}
export default en_US



// WEBPACK FOOTER //
// ./src/pages/build902/i18n/langs/en_US.js